import React, { useState } from 'react'
import { Tabs } from 'antd'

// Component
import MainHeader from '../../components/MainHeader'
import NewTrade from './NewTrade'
import PendingTrade from './PendingTrade'

const TeamTrade = () => {
  const [tab, setTab] = useState(1)

  const items = [
    {
      key: '1',
      label: 'New Trade',
      children: <NewTrade tab={tab} />,
    },
    {
      key: '2',
      label: 'Pending Trade',
      children: <PendingTrade tab={tab} />,
    },
  ]

  return (
    <div className='practice_squad_container team_trade_main'>
      <MainHeader />

      <hr className='divider' />

      <h1 className='heading'>TEAM TRADE NEW</h1>

      <Tabs size='large' defaultActiveKey='1' items={items} onChange={(key) => setTab(key)} />
    </div>
  )
}

export default TeamTrade
